import {
  AccordionContent,
  AccordionItem,
  Accordion,
  AccordionTrigger,
} from '@florencelabs/accordion';
import { MaterialSymbol } from '@florencelabs/icons';
import React, { useId } from 'react';
import { useAnalytics } from '@provider-directory/components/analytics/analytics-provider';

import './footer-accordion.css';

interface AccordionData {
  id: string;
  title: string;
  links: {
    href?: string;
    text: string;
    analyticsText: string;
    onClick?: () => void;
  }[];
}

interface FooterAccordionProps {
  accordionData: AccordionData[];
}

export const MEACFooterAccordion: React.FC<FooterAccordionProps> = ({
  accordionData,
}) => {
  const instanceId = useId();
  const analytics = useAnalytics();
  return (
    <Accordion type={'multiple'}>
      {accordionData.map((section) => (
        <AccordionItem
          value={`${instanceId}-${section.id}`}
          key={section.id}
          className={'meac-accordion__item'}
        >
          <AccordionTrigger
            customIcon={<MaterialSymbol name={'chevron_left'} />}
            className={'meac-accordion__trigger'}
          >
            {section.title}
          </AccordionTrigger>
          <AccordionContent>
            <div className={'meac-accordion__item__content grid gap-4'}>
              {section.links.map((link) => {
                if (link.onClick) {
                  return (
                    <button
                      key={link.text}
                      onClick={() => {
                        link.onClick?.();
                        analytics.navigationClickEvent({
                          navigationType: 'footer',
                          clickText: link.analyticsText,
                          linkType: 'link',
                        });
                      }}
                      className={'meac-footer__link'}
                      type={'button'}
                    >
                      {link.text}
                    </button>
                  );
                }
                return (
                  <a
                    key={link.text}
                    href={link.href}
                    className={'meac-footer__link'}
                    onClick={() => {
                      analytics.navigationClickEvent({
                        navigationType: 'footer',
                        clickText: link.analyticsText,
                        linkType: 'link',
                      });
                    }}
                  >
                    {link.text}
                  </a>
                );
              })}
            </div>
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
};
